module.exports = __webpack_public_path__ + "static/img/swiper-3.bd91300.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/swiper-3.jpg
// module id = 5
// module chunks = 1